import styled from 'styled-components';
import { Row } from 'components/Grid';

export const Section = styled.section`
  padding: 44px 0;
  background-color: #fff;
`;

export const Title = styled.h5`
  margin-bottom: 20px;
  font-weight: 600;
  color: #252d31;
`;

export const List = styled.ul`
  display: block;
`;

export const Item = styled.a`
  margin-bottom: 11px;
  color: #626e75;
`;

export const Download = styled.img`
  cursor: pointer;
  height: 40px;
  width: 100%;
  margin-right: 16px;
  max-width: 135px;

  &:hover {
    opacity: 0.7;
  }
`;

export const SocialMediaButton = styled.button`
  background: none;
  border: none;
  outline: none;
`;

export const SocialMedia = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  margin-right: 16px;

  ${({ name }) => (`
    background: url("/assets/images/footer/social/${name}.svg") no-repeat;

    &:hover {
      background: url("/assets/images/footer/social/${name}-hover.svg") no-repeat;
    }
  `)}
`;

export const StyledRow = styled(Row)`
  margin: 0 !important;
`;

export const CompanyInfo = styled.span`
  text-align: center;
  color: #626e75;
  font-size: 12px;

  margin-bottom: 24px;
`;